import React from 'react';

import appStyles from './AlmeApp.styles';

import { withStyles, WithStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { AlmeConfig } from '../../models/AlmeConfig';

import {
    Theme, Accordion, AccordionDetails, AccordionSummary,
    Typography, Container, Box,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AlmeFooterConfigTool from '../AlmeFooter/AlmeFooterConfigTool';
import { AlmeFooterConfig } from '../AlmeFooter/AlmeFooterConfig';
import AlmeLaunchPointConfigTool from '../AlmeLaunchPoint/AlmeLaunchPointConfigTool';
import { AlmeLaunchPointConfig } from '../AlmeLaunchPoint/AlmeLaunchPointConfig';
import AlmeHeaderConfigTool from '../AlmeHeader/AlmeHeaderConfigTool';
import { AlmeHeaderConfig } from '../AlmeHeader/AlmeHeaderConfig';
import { AlmeHistoryConfig } from '../AlmeHistory/AlmeHistoryConfig';
import AlmeHistoryConfigTool from '../AlmeHistory/AlmeHistoryConfigTool';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '60%',
        },
    }),
);

interface AlmeFooterProps extends WithStyles<typeof appStyles> {
    almeConfig: AlmeConfig;
    setConfigState: (almeConfig: AlmeConfig) => void;
}

const AlmeAppConfigTool: React.FC<AlmeFooterProps> = (props: AlmeFooterProps) => {
    const classes = useStyles();

    const onHeaderConfigChange = (headerConfig: AlmeHeaderConfig): void => {
        const almeConfig: AlmeConfig = {
            ...props.almeConfig,
            header: {
                ...headerConfig.header,
            },
        };
        props.setConfigState(almeConfig);
    };

    const onHistoryConfigChange = (headerConfig: AlmeHistoryConfig): void => {
        const almeConfig: AlmeConfig = {
            ...props.almeConfig,
            history: {
                ...headerConfig.history,
            },
        };
        props.setConfigState(almeConfig);
    };

    const onFooterConfigChange = (footerConfig: AlmeFooterConfig): void => {
        const almeConfig: AlmeConfig = {
            ...props.almeConfig,
            footer: {
                ...footerConfig.footer,
            },
        };
        props.setConfigState(almeConfig);
    };

    const onLaunchPointConfigChange = (launchConfig: AlmeLaunchPointConfig): void => {
        const almeConfig: AlmeConfig = {
            ...props.almeConfig,
            launchPoint: {
                ...launchConfig.launchPoint,
            },
        };
        props.setConfigState(almeConfig);
    };

    return (
        <Box className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-alme-app-config-tool-content"
                    id="panel-alme-app-config-tool-header"
                >
                    <Typography variant='h6'>Alme App Config Tools</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Container>
                        <AlmeHeaderConfigTool almeConfig={props.almeConfig} onConfigChange={onHeaderConfigChange} />
                        <AlmeHistoryConfigTool almeConfig={props.almeConfig} onConfigChange={onHistoryConfigChange} />
                        <AlmeFooterConfigTool almeConfig={props.almeConfig} onConfigChange={onFooterConfigChange} />
                        <AlmeLaunchPointConfigTool almeConfig={props.almeConfig} onConfigChange={onLaunchPointConfigChange} />
                    </Container>
                </AccordionDetails>
            </Accordion>
        </Box >
    );
};

export default withStyles(appStyles)(AlmeAppConfigTool);